import { useTheme } from 'antd-style'

import { TradeSessionStatus } from '../../../../../../pages/TradeSession/enums/TradeSessionStatus'

import { HomeTradeSessionStatusBarProps } from './interface'

export const HomeTradeSessionStatusBar = ({
  statusInfo: { status, timeLabel, duration }
}: HomeTradeSessionStatusBarProps) => {
  const theme = useTheme()
  let text = ''

  switch (status) {
    case TradeSessionStatus.WAIT_APPLY_START:
      text = `距报名开始：${duration.format('DD天 HH时 mm分 ss秒')}`
      break
    case TradeSessionStatus.APPLYING:
      text = `距报名结束：${duration.format('DD天 HH时 mm分 ss秒')}`
      break
    case TradeSessionStatus.WAIT_BID_START:
    case TradeSessionStatus.BIDDING:
      text = `${timeLabel}：${duration.format('DD天 HH时 mm分 ss秒')}`
      break
    case TradeSessionStatus.BID_END:
      text = '已结束'
      break
    default:
      break
  }

  return (
    <div
      style={{
        fontWeight: theme.fontWeightStrong,
        color: theme.colorBgBase,
        paddingInlineStart: theme.paddingSM
      }}
    >
      {text}
    </div>
  )
}
